<!-- {{ thesesResource.mainAuthor.firstName + ' ' + thesesResource.mainAuthor.middleName }} -->
<div class="container-fluid" style="padding-left: 10%; padding-right: 10%; padding-top: 20px;">

    <span class="text-center">
        <h1>Тезис</h1>
        <h3>Пошаговое заполнение информации о тезисе на конференцию</h3>
        <h4><b><u>&laquo;{{ confName }}&raquo;</u></b></h4>
    </span>
    <br>

    <!-- header="Уважаемый, Юзернейм Юзернеймович!" -->

    <p-messages severity="success" *ngIf="isFormReady">
      <ng-template pTemplate>
        <div class="flex flex-column">
          <h4 class="alert-heading">
            {{ thesesResource.mainAuthor.firstName + ' ' + thesesResource.mainAuthor.middleName }}, ваш тезис успешно зарегистрирован!
        </h4>
        <p>На электронную почту <b><u>{{ thesesResource.mainAuthor.contactEmail }}</u></b>, указанную при регистрации, отправлено сообщение. В письме указана сслыка, по которой вы можете отслеживать статус рецензирования вашего тезиса.</p>
        </div>
      </ng-template>
  </p-messages>

    <p-card
        [style]="{width: '100%'}"
        styleClass="p-card-shadow"
        *ngIf="isFormReady"
    >
        <div
            *ngIf="true"
            [innerHtml]="emailMsg"
        ></div>
        <br>

        <ng-template pTemplate="footer">

            <!-- <p-button
                label="На главную"
                icon="pi pi-home"
                styleClass="p-button-secondary"
                [style]="{'margin-left': '.5em', 'margin-top': '.5em'}"
                (click)="goHome()"
            ></p-button> -->

            <p-button
                label="Новый тезис"
                icon="pi pi-plus-circle"
                [style]="{'margin-left': '.5em', 'margin-top': '.5em'}"
                (click)="addNewTheses()"
            ></p-button>

            <button
                pButton
                pRipple
                type="button"
                label="Информация о тезисе"
                class="p-button-info"
                icon="pi pi-info-circle"
                [style]="{'margin-left': '.5em', 'margin-top': '.5em'}"
                (click)="viewTheses()"
            ></button>

        </ng-template>

    </p-card>
</div>
